import { AnyAction } from 'redux'
import {
  FlightBookingForm,
  FlightCity,
  FlightOffer,
  FlightSearchValues,
  FlightTripBooking,
  FlightTripsListMeta,
} from '@/components/flight/types'
import {
  BOOK_FLIGHT,
  FETCH_FLIGHT_CITIES,
  FETCH_FLIGHT_SEARCH,
  FETCH_FLIGHT_SEARCHED_CITIES,
  FETCH_FLIGHT_TRIPS,
  SET_FLIGHT_BOOKING_FORM,
  SET_FLIGHT_SEARCH,
  SET_FLIGHT_SEARCH_RESULTS,
  SET_SELECTED_FLIGHT_OFFER,
} from '../actions/types'

export interface FlightState {
  cities: {
    data: FlightCity[]
    loading: boolean
  }
  searchedCities: {
    data: FlightCity[]
    loading: boolean
  }
  search: FlightSearchValues
  searchResults: FlightOffer[]
  searchResultStatus: string
  searchErrorMessage: string
  searchLoading: boolean
  selectedOffer: FlightOffer | null
  bookingForm: FlightBookingForm
  booking: {
    loading: boolean
  }
  trips: {
    items: FlightTripBooking[]
    loading: boolean
    loadingMore: boolean
    meta: FlightTripsListMeta
  }
}

export const defaultFlightBookingForm: FlightBookingForm = {
  passengers: [],
  phoneNumber: '',
  email: '',
}

export const defaultFlightSearch: FlightSearchValues = {
  origin: null,
  destination: null,
  departureDate: '',
  returnDate: '',
  adultCount: 1,
  childCount: 0,
  infantCount: 0,
}

const initialState: FlightState = {
  cities: {
    data: [],
    loading: false,
  },
  searchedCities: {
    data: [],
    loading: false,
  },
  search: defaultFlightSearch,
  searchResults: [],
  searchResultStatus: '',
  searchErrorMessage: '',
  searchLoading: false,
  selectedOffer: null,
  bookingForm: defaultFlightBookingForm,
  booking: {
    loading: false,
  },
  trips: {
    items: [],
    loading: false,
    loadingMore: false,
    meta: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
  },
}

export const flightReducer = (
  state: FlightState = initialState,
  action: AnyAction,
): FlightState => {
  switch (action.type) {
    case FETCH_FLIGHT_CITIES:
      return {
        ...state,
        cities: { data: action.data, loading: action.loading },
      }
    case FETCH_FLIGHT_SEARCHED_CITIES:
      return {
        ...state,
        searchedCities: { data: action.data, loading: action.loading },
      }
    case SET_FLIGHT_SEARCH:
      return { ...state, search: action.values }
    case SET_FLIGHT_SEARCH_RESULTS:
      return { ...state, searchResults: action.offers || [] }
    case FETCH_FLIGHT_SEARCH:
      return {
        ...state,
        searchLoading: action.loading,
        searchResultStatus: action.resultStatus ?? state.searchResultStatus,
        searchErrorMessage:
          action.errorMessage !== undefined
            ? action.errorMessage
            : action.loading
              ? ''
              : state.searchErrorMessage,
        searchResults:
          action.offers !== undefined ? action.offers : state.searchResults,
      }
    case SET_SELECTED_FLIGHT_OFFER:
      return { ...state, selectedOffer: action.offer }
    case SET_FLIGHT_BOOKING_FORM:
      return { ...state, bookingForm: action.form }
    case BOOK_FLIGHT:
      return {
        ...state,
        booking: { loading: action.loading },
      }
    case FETCH_FLIGHT_TRIPS:
      return {
        ...state,
        trips: {
          items: action.items !== undefined ? action.items : state.trips.items,
          loading: action.loading ?? state.trips.loading,
          loadingMore: action.loadingMore ?? false,
          meta: action.meta || state.trips.meta,
        },
      }
    default:
      return state
  }
}
